type FsPermissionDescriptor = { mode?: "read" | "readwrite" }

// A handle's grant, as the two calls that read and raise it. Not exported: a
// caller reads it off `GetHandlePermission` itself.
type HandlePermission = {
  query: (descriptor?: FsPermissionDescriptor) => Promise<PermissionState>
  request: (descriptor?: FsPermissionDescriptor) => Promise<PermissionState>
}

// Handle permission methods are Chromium-only and absent from lib.dom, same as
// the directory picker that hands the handles out.
declare global {
  interface FileSystemHandle {
    queryPermission?: (descriptor?: FsPermissionDescriptor) => Promise<PermissionState>
    requestPermission?: (descriptor?: FsPermissionDescriptor) => Promise<PermissionState>
  }
}

/** A handle's permission calls, or `undefined` where the browser has none.
 *
 * Absent is not denied: browsers without the handle permission API only hand
 * out handles that are already usable, so a caller that gets `undefined` here
 * already has its grant. */
export const GetHandlePermission = (handle: FileSystemHandle): HandlePermission | undefined =>
  handle.queryPermission && handle.requestPermission
    ? {
        query: handle.queryPermission.bind(handle),
        request: handle.requestPermission.bind(handle),
      }
    : undefined
